var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DefaultPageLayout',{attrs:{"headerStyle":{
  'padding-bottom': '61px',
}}},[_c('div',{staticClass:"pb-6"},[_c('div',{staticClass:"fs-20 fs-md-24 font-weight-bold white--text"},[_vm._v(" "+_vm._s(_vm.$t('nav.notifications'))+" ")])]),_c('div',{staticClass:"row px-2"},[(!_vm.isTablet)?_c('v-col',{staticClass:"py-0 px-0",attrs:{"cols":"3"}},[_c('SettingsList')],1):_vm._e(),_c('v-col',{staticClass:"pl-0 pr-0 py-0 pl-lg-6",attrs:{"cols":"12","lg":"9"}},[_c('Settings')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }